// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ebE6Q","detailsBorder":"styles_detailsBorder__1__FM"};